<nav backgroundColor="accent" color="warn" mat-align-tabs="center" mat-tab-nav-bar [tabPanel]="tabPanel"
   mat-stretch-tabs="false">

   <a (click)="activeLink = '/setup/assignment/skills'" [active]="activeLink.startsWith('/setup/assignment/skills')"
      [routerLink]="'/setup/assignment/skills'" mat-tab-link>Skills</a>

   <a (click)="activeLink = '/setup/assignment/skillProfiles'"
      [active]="activeLink.startsWith('/setup/assignment/skillProfiles')"
      [routerLink]="'/setup/assignment/skillProfiles'" mat-tab-link>Skill Profiles</a>

   <a (click)="activeLink = '/setup/assignment/visits'" [active]="activeLink.startsWith('/setup/assignment/visits')"
      [routerLink]="'/setup/assignment/visits'" mat-tab-link>Visit Types</a>

   <a (click)="activeLink = '/setup/assignment/planningSegments'"
      [active]="activeLink.startsWith('/setup/assignment/planningSegments')"
      [routerLink]="'/setup/assignment/planningSegments'" mat-tab-link>Slots</a>

   <a (click)="activeLink = '/setup/assignment/autobook'" [active]="activeLink.startsWith('/setup/assignment/autobook')"
      [routerLink]="'/setup/assignment/autobook'" mat-tab-link>Auto-Book</a>
</nav>
<mat-tab-nav-panel #tabPanel>
   <router-outlet></router-outlet>
</mat-tab-nav-panel>